import * as PIXI from 'pixi.js';
import { CELL_SIZE, EntityColors } from '../constants';
import { WordBoxData } from '../types';
import { wordToNoun } from '../utils';

export class WordBox {
  public type: string;
  public x: number;
  public y: number;
  public dimension: number;
  public connected = false;
  public partOfActiveRule = false;
  private glowPhase: number;
  public sprite: PIXI.Container;
  private graphics: PIXI.Graphics;
  private text: PIXI.Text;

  constructor(data: WordBoxData, dim: number, container: PIXI.Container) {
    this.type = data.type;
    this.x = data.x;
    this.y = data.y;
    this.dimension = dim;
    this.glowPhase = Math.random() * Math.PI * 2;
    
    const spriteContainer = new PIXI.Container();
    this.graphics = new PIXI.Graphics();
    
    const wordText = wordToNoun(this.type);
    this.text = new PIXI.Text({
      text: wordText,
      style: {
        fontSize: wordText.length > 6 ? 9 : 12,
        fill: EntityColors[this.type],
        fontFamily: 'Courier New, monospace',
        fontWeight: 'bold',
      }
    });
    this.text.anchor.set(0.5);
    this.text.x = CELL_SIZE / 2;
    this.text.y = CELL_SIZE / 2;
    
    spriteContainer.addChild(this.graphics);
    spriteContainer.addChild(this.text);
    spriteContainer.x = this.x * CELL_SIZE;
    spriteContainer.y = this.y * CELL_SIZE;
    spriteContainer.alpha = 0;
    spriteContainer.visible = false;
    
    this.sprite = spriteContainer;
    container.addChild(spriteContainer);
    this.updateGraphics();
  }

  public updateGraphics(): void {
    this.graphics.clear();
    
    const color = this.partOfActiveRule ? 0xFFD700 : EntityColors[this.type];
    const glowColor = this.partOfActiveRule ? 0xFFD700 : EntityColors[this.type];
    
    // Outer glow rings
    for (let i = 0; i < 2; i++) {
      this.graphics.rect(1.5 - i * 1.5, 1.5 - i * 1.5, CELL_SIZE - 3 + i * 3, CELL_SIZE - 3 + i * 3);
      this.graphics.stroke({ color: glowColor, width: 1.5, alpha: 0.4 - i * 0.1 });
    }
    
    // Background
    this.graphics.rect(1.5, 1.5, CELL_SIZE - 3, CELL_SIZE - 3);
    this.graphics.fill({ color: this.partOfActiveRule ? 0x1a1a00 : 0x000000, alpha: 0.95 });
    this.graphics.stroke({ color: color, width: this.partOfActiveRule ? 3 : 2 });
    
    this.text.style.fill = color;
  }

  public update(currentDimension: number): void {
    this.glowPhase += 0.05;
    const intensity = Math.sin(this.glowPhase) * 0.3 + 0.7;
    const visible = currentDimension === this.dimension;
    this.sprite.alpha = visible ? intensity : 0;
    this.sprite.visible = visible;
  }

  public destroy(): void {
    if (this.sprite && this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite);
      this.sprite.destroy();
    }
  }
}
